<template>
  <div class="nav-wrap" :class="{ top: isTop }">
    <div class="nav">
      <div
        v-for="item in topBtnList"
        :key="item.type"
        class="top-btn pointer"
        :id="item.id"
      >
        <div class="btn" @click="onBtn(item.type)">
          <img
            class="userImg icon"
            v-if="item.type === 1"
            :src="$store.state.user.headPhoto || defaultImg"
            alt="用户头像"
          />
          <img v-else class="icon" :src="item.icon" alt="icon" />
          <div>{{ item.label }}</div>
          <!-- 购物车数量 -->
          <div
            class="cart-count"
            v-if="item.type === 2 && !!+shoppingCartCount"
          >
            {{ shoppingCartCount }}
          </div>
          <div class="cart-count" v-if="item.type === 6 && !!+sparePartCount">
            {{ sparePartCount }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import icon6 from '@/assets/img/main/nav/icon-6.png'
import icon3 from '@/assets/img/main/nav/icon-3.png'
import icon4 from '@/assets/img/main/nav/icon-4.png'
import icon9 from '@/assets/img/main/nav/icon-9.png'
import icon10 from '@/assets/img/main/nav/icon-10.png'
import icon11 from '@/assets/img/main/nav/icon-11.png'
import icon16 from '@/assets/img/main/nav/icon-14.png'
import defaultImg from '@/assets/img/icon.jpg'
import { getAccessToken } from '@/utils/userInfo'

export default {
  props: {
    isTop: {
      default: false,
      type: Boolean
    }
  },
  data () {
    return {
      defaultImg,
      appImg: require('@/assets/img/appDownload.png'),

      shoppingCartCount: 0,
      sparePartCount: 0
    }
  },
  computed: {
    topBtnList () {
      const list = [
        { label: '我的', icon: defaultImg, type: 1 },
        { label: '购物车', icon: icon6, type: 2, id: 'add_cart_nav' },
        { label: '订单', icon: icon3, type: 5 },
        // { label: '领用车', icon: icon4, type: 6 },
        // { label: '备件领用', icon: icon11, type: 7 },
        { label: '浏览历史', icon: icon16, type: 16 },
        // { label: '咨询', icon: icon9, type: 9 },
        { label: '回到顶部', icon: icon10, type: 10 }
      ]
      if (this.$store.state.user.corpUserInfo.customerId) {
        // 企业站不需要的菜单隐藏
        return list.filter(i => !['领用车', '备件领用'].includes(i.label))
      }
      return list
    }
  },
  created () {
    this.getCartCount()
  },
  watch: {
    '$store.state.shoppingCartCount': function () {
      this.getCartCount()
    },
    '$store.state.lclbDataList': function () {
      this.getCartCount()
    }
  },
  methods: {
    getCartCount () {
      if (getAccessToken() === '' || getAccessToken() === undefined) {
        return false
      }
      // 判断是否是企业站用户 实际调用
      if (this.$store.state.user.corpUserInfo.customerId) {
        this.$http
          .get(`/front/oms/crop-site/shopping-cart/total`)
          .then(({ data: res }) => {
            if (res.code === 0) {
              this.shoppingCartCount = res.data
            }
          })
      } else {
        this.$request
          .get(`/front/consumer/shoppingcart/queryShoppingCartList`)
          .then((_data) => {
            if (!_data) {
              return
            }
            this.shoppingCartCount = _data.ordinaryCount
            this.sparePartCount = _data.sparePartCount
          })
      }
    },
    onBtn (type) {
      switch (type) {
        case 1:
          this.$router.push({
            name: 'basicInfo'
          })
          break
        case 2:
          // 判断是否是企业站用户
          if (this.$store.state.user.corpUserInfo.customerId) {
            this.$router.push({
              name: 'corpWebsite-myShopCart'
            })
          } else {
            this.$router.push({
              name: 'myShopCart'
            })
          }
          break
        case 5:
          this.$router.push({
            name: 'orderList'
          })
          break
        case 6:
          // 判断是否是企业站用户
          if (this.$store.state.user.corpUserInfo.customerId) {
            this.$router.push({
              name: 'corpWebsite-myShopCart'
            })
          } else {
            this.$router.push({
              name: 'mySpareShopCart'
            })
          }
          break
        case 7:
          this.$router.push({
            name: 'spareGetList'
          })
          break
        case 9:
          this.$consultJump(this.$store.state.user)
          break
        case 10:
          this.jumpTop('main-content')
          break

        case 16:
          // 判断是否是企业站用户
          if (this.$store.state.user.corpUserInfo.customerId) {
            this.$router.push({
              name: 'corpWebsite-browseHistory'
            })
          } else {
            this.$router.push({
              name: 'browseHistory'
            })
          }
          break
      }
    },
    jumpTop (domId) {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth' // 可选，平滑滚动效果
      })
    },
    openAPP () {
      this.$alert(
        `<div style="text-align:center;"><img src="${this.appImg}" style="width:100px;" /></div>`,
        '扫码下载APP',
        {
          dangerouslyUseHTMLString: true
        }
      ).catch(() => {})
    }
  }
}
</script>
<style lang="scss" scoped>
.nav-wrap {
  width: 92%;
  position: fixed;
  top: 50vh;
  pointer-events: none;
  z-index: 1000;
  &.top {
    top: 0;
    transform: translateY(50px);

    .nav {
      top: 0;
      transform: none;
    }
  }
}

.nav {
  min-width: 48px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  z-index: 999;
  position: absolute;
  left: calc(100% + 28px);
  top: 0;
  transform: translateY(-50%);
  pointer-events: auto;
  border-radius: 16px;
  background: #ffffff;
  padding: 8px 12px;
  box-sizing: content-box;

  &::-webkit-scrollbar {
    display: none;
    /*隐藏滚动条*/
  }

  .top-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: Alibaba PuHuiTi;
    font-size: 12px;
    font-weight: 400;
    line-height: 16.46px;
    text-align: center;
    color: #5e6066;
    margin: 8px 0;

    .userImg {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      border: 1px solid #fff;
    }
    .icon {
      margin: 0 0 4px;
    }
  }
  .pointer:hover {
    opacity: 0.8;
  }
  .btn {
    position: relative;
    .cart-count {
      position: absolute;
      right: 0px;
      top: -6px;
      border-radius: 8px;
      background: #e93037;
      font-size: 12px;
      font-weight: bold;
      color: #fff;
      text-align: center;
      line-height: 16px;
      padding: 0 4px;
      box-shadow: 0px 2px 4px 0px #e9303766;
    }
  }
}
</style>
